import { createRecentVersionData } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { ISwiperContainerNode, Paint, PartialNode } from "../type";

const defaultPaint: Paint[] = [
  {
    type: "SOLID",
    visible: false,
    color: {
      r: 255,
      g: 255,
      b: 255,
    },
    opacity: 0.25,
  },
  {
    type: "IMAGE",
    visible: false,
    fileType: "png",
    path: "",
    backgroundSize: "COVER",
  },
  {
    type: "SOLID",
    visible: true,
    color: {
      r: 200,
      g: 200,
      b: 200,
    },
    opacity: 1,
  },
];

const createSwiperContainerNode = (
  data?: PartialNode<ISwiperContainerNode>
): ISwiperContainerNode => {
  // swiper-container에서 배경색을 사용함에 따라 기존 swiper-container의 fills가 빈배열이라면 기본값을 채워줌
  const fields = createRecentVersionData(data);
  const result: ISwiperContainerNode = {
    type: "SWIPER_CONTAINER",
    id: shortUUID.generate(),
    pluginData: {
      contentEditorPropSeq: 0,
      contentMeta: [],
    },
    position: { type: "RELATIVE" },
    reactions: [],
    name: "슬라이드 영역",

    width: {
      value: 100,
      unit: "%",
    },

    ...(!fields?.aspectRatio && {
      height: {
        value: 300,
        unit: "px",
      },
    }),
    locked: false,
    visible: true,

    strokes: [],
    strokeWeight: 0,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],
    cornerRadius: {
      bl: { unit: "px", value: 0 },
      br: { unit: "px", value: 0 },
      tl: { unit: "px", value: 0 },
      tr: { unit: "px", value: 0 },
    },

    fills: [],

    effects: [],
    alignHorizontal: "LEFT",
    loop: false,
    speed: 300,
    enabled: true,
    autoHeight: false,
    preventSlideOnVideoEnd: false,
  };

  Object.assign(result, {
    ...fields,
    // swiper-container에서 배경색을 사용함에 따라 기존 swiper-container의 fills가 빈배열이라면 기본값을 채워줌
    ...(fields?.fills?.length !== 3 && { fills: defaultPaint }),
  });

  return result;
};

export default createSwiperContainerNode;
